export default function getExportingJobsHistory(): string {
  return `/exporting/jobs/history?limit=999`;
}
